import {
  sendFormPageOne,
  sendFormPageTwo,
  sendFormPageThree,
  sendFormPageFour,
  sendFormPageFive,
  sendFormPageSix,
  updateFormPageOne,
  updateFormPageTwo,
  updateFormPageThree,
  updateFormPageFour,
  updateFormPageFive,
  updateFormPageSix,
  getDataFormPageOne,
  getDataFormPageTwo,
  getDataFormPageThree,
  getDataFormPageFour,
  getDataFormPageFive,
  getDataFormPageSix
} from "./sendForm";

const getFormPageServices = {
  1: (dni) => getDataFormPageOne(dni),
  2: (dni) => getDataFormPageTwo(dni),
  3: (dni) => getDataFormPageThree(dni),
  4: (dni) => getDataFormPageFour(dni),
  5: (dni) => getDataFormPageFive(dni),
  6: (dni) => getDataFormPageSix(dni),
}; 

const createFormPageServices = {
  1: (values) => sendFormPageOne(values) ,
  2: (values) => sendFormPageTwo(values),
  3: (values) => sendFormPageThree(values),
  4: (values) => sendFormPageFour(values),
  5: (values) => sendFormPageFive(values),
  6: (values) => sendFormPageSix(values)
};

const editFormPageServices = {
  1: (values) => updateFormPageOne(values) ,
  2: (values) => updateFormPageTwo(values),
  3: (values) => updateFormPageThree(values),
  4: (values) => updateFormPageFour(values),
  5: (values) => updateFormPageFive(values),
  6: (values) => updateFormPageSix(values),
};

export const sendFormPages = async (values, page, actions) => {
  if(actions === 'save' || actions === 'finish'){
    const formPageService = createFormPageServices[page];
    const isValid = await formPageService(values);
    return isValid;
  } else if(actions === 'edit'){
    const formPageService = editFormPageServices[page];
    const isValid = await formPageService(values);
    return isValid;
  }
};

export const getFormPages = async (dni, page)=> {
  const formPageService = getFormPageServices[page];
  const data = await formPageService(dni);
  return data;
}
